module.exports = __webpack_public_path__ + "static/media/plan.818024fa.png";